module.exports = __webpack_public_path__ + "static/media/not-found-light.e0355c5a.svg";